module.exports = __webpack_public_path__ + "img/ceramic@2x.91b3145.jpg";